// Responsive constants for the Library screen

// Card width: scales across 4 breakpoints
export const cardWidth = 'w-[280px] sm:w-[312px] md:w-[340px] lg:w-[360px]';

// Horizontal padding for page sections — shared standard
export const sectionPadding = 'px-6 sm:px-8 md:px-10 lg:px-12';

// Section heading: 26px at ≤390px, 30→32→34px above
export const sectionHeading = 'max-[390px]:text-[26px] text-[30px] md:text-[32px] lg:text-[34px] font-bold text-[#ffffff]';

// Card title: 20→22→24px
export const cardTitle = 'text-[20px] md:text-[22px] lg:text-[24px] font-medium text-[#1B2831]';

// Card description: 14→15→16px
export const cardDescription = 'text-[14px] md:text-[15px] lg:text-[16px] text-[#323B46]';

// Card metadata (icons + labels): fixed 12px — captions stay fixed per guidelines
export const cardMetadata = 'text-[12px] text-[#323B46]';

// Card padding: 16→18→20→22px (Expert Tips card pattern)
export const cardPadding = 'p-4 sm:p-[18px] md:p-5 lg:p-[22px]';

// Card gap between elements: 10→11→12→14px
export const cardGap = 'gap-[10px] sm:gap-[11px] md:gap-[12px] lg:gap-[14px]';

// Image height: fixed 180px inside the constrained card — scales proportionally with card width
export const cardImageHeight = 'h-[180px] md:h-[200px] lg:h-[210px]';

// CTA button height: 48→56px (Activity Details button pattern)
export const ctaButtonHeight = 'h-12 md:h-14';

// Accordion row height: 56→60→64px
export const accordionRowHeight = 'h-[56px] md:h-[60px] lg:h-[64px]';

// Accordion row padding: scales with standard pattern
export const accordionRowPadding = 'px-4 sm:px-5 md:px-6';

// Accordion pack name: 16→18→20px
export const accordionPackName = 'text-[16px] md:text-[18px] lg:text-[20px] font-semibold text-white';

// Accordion arrow icon: 24→26→28px (Expert Tips arrow pattern)
export const accordionArrowSize = 'w-6 h-6 md:w-[26px] md:h-[26px] lg:w-7 lg:h-7';

// Skeleton color for library (activity library uses gray-200)
export const skeletonBg = 'bg-gray-200';
